module.exports = "<div class=\"giph preload\">\n  <img src=\"assets/images/loading.gif\" alt=\"nic cage!\" />\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/common/giph/giph.html
 ** module id = 72
 ** module chunks = 0
 **/